import { Trans } from '@lingui/react/macro';

import { someActionsDontHaveWorkshopAndClientPrices } from '@/models/article';
import { ArticleWithRelations } from '@/models/request';
import { canActOnBehalfOfNonDigitalizedWorkshop } from '@/models/user';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';
import { useRequestContext } from '@/routes/Requests/contexts/RequestContext';
import { useCurrentSession } from '@/services/auth';

import { BaseMessage } from './BaseMessage';

export const ProcessingStepMessage = ({ article }: { article: ArticleWithRelations }) => {
  const { workflow } = useRequestContext();
  const { request } = useArticleContext();
  const { currentSession } = useCurrentSession();

  const canActOnBehalfOfWorkshop = canActOnBehalfOfNonDigitalizedWorkshop({
    user: currentSession,
    request,
    workflow,
  });

  const preventConfirmReception = someActionsDontHaveWorkshopAndClientPrices({ article, request });

  return (
    <BaseMessage
      title={<Trans id="article.step-message.processing">The item is being processed</Trans>}
      message={
        <>
          <Trans id="article.step-message.processing.message">
            The item is being handled by a workshop that doesn't have access to the application.
          </Trans>
          {canActOnBehalfOfWorkshop && !preventConfirmReception && (
            <>
              {' '}
              <Trans id="article.step-message.processing.message.action">
                Once it is sent back, please confirm reception.
              </Trans>
            </>
          )}
          {preventConfirmReception && (
            <>
              {' '}
              <Trans id="article.step-message.processing.message.no-reception">
                One or more prices are missing, an analysis step is required before proceeding with
                reception.
              </Trans>
            </>
          )}
        </>
      }
      article={article}
    />
  );
};
